export default {
  experimental: 'Timeline expérimentale',
  timelineIsEmpty: 'aucun message',
  table: {
    headers: {
      author: 'Auteur',
      title: 'Titre',
      content: 'Contenu',
      category: 'Catégorie',
      created_at: 'Date de création',
      message_updated_at: 'Date de MAJ',
      user_timeline_id: 'ID (UserTimeline)',
      timeline_ordered_key: 'Clé pour pagination'
    }
  },
  buttons: {
    sendMessage: 'Envoyer un message'
  },
  sendMessage: {
    title: 'Titre',
    content: 'Contenu',
    messageSent: 'message envoyé'
  }
}
